import styled from 'styled-components';
import { media } from '~/styles/mixins';
import ResponsiveText from '~/components/ResponsiveText';

export const HeroContainer = styled.div`
	display: flex;
	justify-content: center;
	max-width: 1540px;
	margin: 0 auto;
	width: 100%;
`;

export const HeroWrap = styled.div`
	width: 100%;
	padding: 30px 120px 40px 120px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 20px;
	${media.belowLarge`
		padding: 12px 20px 40px;
		flex-direction: column;
	`}
`;

export const LeftSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 32px;
	flex-grow: 4;
	${media.large`
		width: min-content;
		align-items: flex-start;
	`}
	& > * {
		text-align: center;
		${media.large`
		text-align: left;
	`}
	}
`;

export const Title = styled(ResponsiveText)`
	${media.medium`
		font-size: 80px;
		line-height: 90px;
	`}
`;

export const TitleHighlight = styled.span`
	color: ${({ theme }) =>
		theme.tokens.COLOR_TOKENS_TEXT_INVERTIBLE_PRIMARY_PRIMARY};
`;

export const Subtitle = styled(ResponsiveText)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	width: ${({ shortWidth }) => (shortWidth ? '75%' : '100%')};
	padding-right: 60px;

	${media.belowLarge`
		padding-right: 0;
		width: 100%;
		align-items: center;
		text-align: center;
	`}
`;

export const Spacer = styled.div`
	flex-grow: 1;
	${media.belowLarge`
		display: none;
	`}
`;

export const SignupWrap = styled.div`
	width: 420px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	${media.belowLarge`
		display: none;
	`}
`;
